import { useEffect, useState, useRef } from "react";
import { useParams, useLocation } from "react-router-dom";
import _axios from "../../../../httpService";
import axios from "axios";
import { toast } from "react-toastify";
import ReportChart from "./ReportChart";
import ReportConditions from "./ReportConditions";

const AddNewReport = () => {
  const [entityItems, setEntityItems] = useState([]);
  const [showData, setShowData] = useState("");
  const [enteredChartData, setEnteredChartData] = useState([]);
  const [enteredConditionData, setEnteredConditionData] = useState([]);
  const [chartAxes, setChartAxes] = useState([]);
  const [entity, setentity] = useState("nullSelect");
  const [entityComp, setEntityComp] = useState("");
  const [caption, setCaption] = useState("");
  const [mode, setMode] = useState("");
  const [tableData, setTableData] = useState(true);
  const [reportEditData, setReportEditData] = useState([]);
  const [conditionEditData, setConditionEditData] = useState([]);

  const location = useLocation();

  const formRef = useRef(null);
  let { id } = useParams();

  useEffect(() => {
    setMode(location.state.mode);
    axios({
      method: "get",
      url: `${localStorage.getItem("apiUrl2")}w/gre/`,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => setEntityItems(response.data));
  }, [location.state.mode]);
  useEffect(() => {
    if (mode === "edit" && id !== undefined) {
      _axios
        .post(`${localStorage.getItem("apiUrl2")}w/grd/`, { id: id })
        .then((response) => {
          setReportEditData(response.data);
          setentity(response.data.details.reportDetails.entity);
          setEntityComp(response.data.details.reportDetails.entity);
          setChartAxes(response.data.selectBox.fields);
          setConditionEditData(response.data.details.enteredConditionData);
          setEnteredConditionData(response.data.details.enteredConditionData);
        });
    }
  }, [id, mode, entityComp]);
  useEffect(() => {
    if (reportEditData.length !== 0 && mode === "edit") {
      // setentity(reportEditData.details.reportDetails.entity);
      let data = [
        reportEditData.details.enteredChartData,
        reportEditData.details.reportDetails,
      ];
      for (let item of data) {
        let form = formRef.current;
        for (const key in item) {
          if (form[key] !== undefined) {
            if (form[key].type === "checkbox") {
              form[key].checked = item[key];
            } else {
              form[key].value = item[key];
            }
          }
        }
      }
    } else if (mode === "add") {
      let formItems = formRef.current.elements;
      for (let item of formItems) {
        item.value = "";
      }
      setConditionEditData([]);
      setEnteredConditionData([]);
    }
  }, [mode, reportEditData]);

  const changeEntityHandler = (e) => {
    let value = e.target.value;
    setentity(value);
    setEntityComp(value);
    axios({
      method: "post",
      url: `${localStorage.getItem("apiUrl2")}w/grf/`,
      params: { key: value },
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }).then((response) => setChartAxes(response.data));
  };
  const changeDataShowHandler = (e) => {
    if (e.target.checked) {
      setShowData("true");
    } else {
      setShowData("");
    }
  };
  const changeCaptionHandler = (e) => {
    let value = e.target.value;
    setCaption(value);
  };
  const saveChartDataHandler = (enteredChartData) => {
    setEnteredChartData(enteredChartData);
  };
  const saveConditionDataHandler = (data) => {
    setEnteredConditionData([...enteredConditionData, data]);
  };
  const submitHandler = (e) => {
    e.preventDefault();
    if (
      mode === "edit" &&
      (caption.trim().length === 0 || entity.trim().length === 0)
    ) {
      toast.error("نام موجودیت و کپشن را انتخاب کنید");
    } else if (mode === "edit" && enteredChartData.length === 0) {
      toast.error("لطفا قسمت اطلاعات نمودار را تکمیل و سپس تایید نمایید");
    } else {
      const reportForm =
        mode === "edit"
          ? {
              reportDetails: {
                entity: entity,
                caption: caption,
                table: showData,
                id: id,
              },
              enteredChartData,
              enteredConditionData,
            }
          : {
              reportDetails: {
                entity: entity,
                caption: caption,
                table: showData,
              },
              enteredChartData,
              enteredConditionData,
            };
      let path = mode === "edit" ? "y/er/" : "x/nr/";
      _axios.post(path, reportForm).then((response) => {
        toast.success(response.data.message);
      });
      console.log(reportForm);
      formRef.current.reset();
      setEnteredConditionData([]);
      setEnteredChartData([]);
      setShowData("");
      setChartAxes("");
      setTableData(false);
    }
  };

  return (
    <div>
      <form ref={formRef} onSubmit={submitHandler} className="formChanges">
        <div className="title-template">
          <div className="line"></div>
          <div className="lable-box-title-new">
            <label className="headLabel">فرم گزارش ساز</label>
          </div>
        </div>
        <>
          <div className="selectWidthComplete">
            <label
              htmlFor="idEntity"
              className=" control-label form-label labelMargin"
            >
              نام موجودیت
            </label>
            <select
              className="inputBox"
              id="id4"
              name="entity"
              defaultValue={"nullSelect"}
              onChange={changeEntityHandler}
              required
            >
              <option value={"nullSelect"}>
                گزینه مورد نظر خود را انتخاب کنید
              </option>
              {entityItems.map((item) => (
                <option key={item.key} value={item.key}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <div className="selectBox-sides">
            <div className="CheckBOX mb-2">
              <input
                className="form-check-input"
                type="checkbox"
                value="table"
                id="flexCheckDefault"
                name="table"
                onClick={changeDataShowHandler}
              />
              <label className="" htmlFor="flexCheck">
                نمایش دیتا به صورت جدول
              </label>
            </div>
          </div>
          <div className="">
            <label
              htmlFor="InputName"
              className="control-lable form-label labelMargin"
            >
              کپشن
            </label>
            <input
              type="text"
              className="form-control inputBox"
              onChange={changeCaptionHandler}
              placeholder="متن مورد نظر خود را وارد کنید"
              name="caption"
              required
            />
            <label className="error-msg"></label>
          </div>
          <ReportChart
            data={chartAxes}
            onSaveReportChartData={saveChartDataHandler}
          />
          <ReportConditions
            field={entityComp}
            data={tableData}
            onSaveReportCondition={saveConditionDataHandler}
            table={conditionEditData}
          />
        </>
        {/* <div className="title-template">
          <div className="line-dashed"></div>
          <div className="lable-box-title-new">
            <label className="headLabel">میانبرها</label>
          </div>
        </div>

        <div className="sec-apart">
          <label className="lable-box">عملیات</label>
          <div className="flexRow">
            <div className="ChechBOX">
              <input
                type="radio"
                className="form-check-input"
                id="radio1"
                name="optradio"
                value="option1"
                checked
              />
              <label className="form-check-label" htmlFor="radio1">
                عمومی
              </label>
            </div>
            <div className="ChechBOX">
              <input
                type="radio"
                className="form-check-input"
                id="radio2"
                name="optradio"
                value="option1"
                checked
              />
              <label className="form-check-label" htmlFor="radio2">
                اختصاصی
              </label>
            </div>
            <div className="CheckBOX">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="50"
                name=""
              />
              <label className="" htmlFor="50">
                عملیات
              </label>
            </div>
            <div className="CheckBOX">
              <input
                className="form-check-input"
                type="checkbox"
                value=""
                id="60"
                name=""
              />
              <label className="" htmlFor="60">
                پیشخوان
              </label>
            </div>
          </div>
        </div>

        <div className="sec-apart">
          <label className="lable-box">فهرست</label>

          <div className="tableBox resSizeTable">
            <table className="resFontTable">
              <thead className="borderHead">
                <tr className="headTable">
                  <th>مشخصه کاربر</th>
                  <th>شماره موبایل</th>
                  <th>سطح دسترسی</th>
                </tr>
              </thead>

              <tbody>
                <tr className="tableBody">
                  <td>محمد محمدی</td>
                  <td>09117776655</td>
                  <td>به همه رکوردها</td>
                </tr>
                <tr className="tableBody">
                  <td>محمد محمدی</td>
                  <td>09117776655</td>
                  <td>به همه رکوردها</td>
                </tr>
                <tr className="tableBody">
                  <td>محمد محمدی</td>
                  <td>09117776655</td>
                  <td>به همه رکوردها</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="button-box mx-auto my-3 twoBtn ">
            <button type="button" className=" btn-cancel">
              انصراف
            </button>
            <button
              type="submit"
              className=" btn-confirm"
              onClick={(e) => e.preventDefault()}
            >
              ثبت
            </button>
          </div>
        </div> */}
        <div className="button-box mx-auto my-3 twoBtn ">
          <button type="button" className=" btn-cancel">
            انصراف
          </button>
          <button type="submit" className=" btn-confirm">
            ثبت
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddNewReport;
